import React, { useEffect, useState } from "react";
import Breadcrumbs from "../common/breadcrumbs";
import AOS from "aos";
import "aos/dist/aos.css";
import { useSelector } from "react-redux";
import { ContactUs } from "../../core/data/interface/interface";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import Header from "../common/header";
import Footer from "../common/footer";
import { getBookingRequestMsg, MakeRequest } from "../../functionsMaster";

const Contact = () => {
	const data = useSelector((state: any) => state.rootReducer.contactdata);
	// let message = localStorage.getItem('forMessage');
	// localStorage.removeItem('forMessage');
	// if (message) {
	//   const filPickUpDate = localStorage.getItem('filPickUpDate');
	//   const filDropOffDate = localStorage.getItem('filDropOffDate');
	//   if (filPickUpDate) {
	//     message = `${message} ${filPickUpDate}`;
	//   }
	//   if (filDropOffDate) {
	//     message = `${message} to ${filDropOffDate}`;
	//   }
	// }

	const [response, setResponse] = useState({ status: 0, message: '' });
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		phone: '',
		message: getBookingRequestMsg(),
		apiCall: false
	});

	useEffect(() => {
		AOS.init({ duration: 1200, once: true });
	}, []);

	async function submitContactRequest() {
		setFormData({ ...formData, apiCall: true });
		const data = await MakeRequest(formData);
		setResponse(data);
		setFormData({
			name: '',
			email: '',
			phone: '',
			message,
			apiCall: false
		});
		return false;
	}

	return (
		<div className="main-wrapper">
			<Header />
			<Breadcrumbs title="Contact us" subtitle="Pages" />
			<section className="contact-section p-2">
				<div className="container">
					<div
						className="form-info-area"
						data-aos="fade-down"
						data-aos-duration={1200}
						data-aos-delay="0.5"
					>
						<div className="row">
							<div className="col-lg-6">
								<div className="contact-info-area">
									<div className="row">
										{data.map((info: ContactUs, index: number) => (
											<Link
												to={info.link}
												key={index}
												className="col-lg-6 col-md-6 col-6 d-flex mt-3"
												data-aos="fade-down"
												data-aos-duration={1200}
												data-aos-delay="0.1"
											>
												<div className="single-contact-info flex-fill">
													<span>
														<i className={info.icon} />
													</span>
													<h3>{info.title}</h3>
													<span>{info.text}</span>
												</div>
											</Link>
										))}
									</div>
								</div>
								<ImageWithBasePath
									src="assets/img/contact-info.jpg"
									className="img-fluid d-none"
									alt="Contact"
								/>
							</div>
							<div className="col-lg-6">
								<form
									action="/"
									onSubmit={(e) => {
										e.preventDefault();
										submitContactRequest();
									}}
									style={{ border: '1px solid #dedede', padding: '20px', borderRadius: '10px', background: '#ffdbae' }}
								>
									<div className="row">
										<h1>Get in touch!</h1>
										<div className="col-md-12">
											<div className="input-block">
												<label>
													Name <span className="text-danger">*</span>
												</label>
												<input
													required
													type="text"
													className="form-control"
													placeholder="Enter Name"
													value={formData.name}
													onChange={(e) => {
														setFormData({ ...formData, name: e.target.value });
													}}
												/>
											</div>
										</div>
										<div className="col-md-12">
											<div className="input-block">
												<label>
													Email Address <span className="text-danger">*</span>
												</label>
												<input
													type="email"
													required
													value={formData.email}
													className="form-control"
													placeholder="Enter Email Address"
													onChange={(e) => {
														setFormData({ ...formData, email: e.target.value });
													}}
												/>
											</div>
										</div>
										<div className="col-md-12">
											<div className="input-block">
												<label>
													Mobile <span className="text-danger">*</span>
												</label>
												<input
													required
													value={formData.phone}
													type="text"
													className="form-control"
													placeholder="Enter Mobile"
													onChange={(e) => {
														setFormData({ ...formData, phone: e.target.value });
													}}
												/>
											</div>
										</div>
										<div className="col-md-12">
											<div className="input-block">
												<label>Comments</label>
												<textarea
													className="form-control"
													rows={4}
													placeholder="Enter Message"
													defaultValue={"\t\t\t\t\t\t\t\t\t\t\t"}
													value={formData.message ? formData.message : ' '}
													onChange={(e) => {
														setFormData({ ...formData, message: e.target.value });
													}}
												/>
											</div>
										</div>
									</div>
									<div className={`${response.message ? '' : 'd-none'} alert alert-${response.status === 1 ? 'success' : 'danger'}`}>
										{response.status === 1 ? 'Thank you for reaching out. We have received your contact request and will respond to you shortly.' : response.message}
									</div>
									{formData.apiCall ? (
										<button type="button" className="btn contact-btn" disabled>Sending</button>
									) : (
										<button type="submit" className="btn contact-btn">Send Enquiry</button>
									)}
								</form>
							</div>
						</div>


					</div>
				</div>
			</section>
			{/* ✅ Google Map Embed Section */}
			<section>
				<h2 className="text-center mb-4">Find Us on Google Maps</h2>
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3628.8544437202186!2d73.694642!3d24.559691599999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3967ef83528f7517%3A0x150b459cc254ff!2sNamo%20Cars%20%E2%80%93%20Self%20Drive%20Car%20Rental%20in%20Udaipur!5e0!3m2!1sen!2sin!4v1761974259773!5m2!1sen!2sin"
					style={{
						width: '100%',
						height: '60vh',
						border: 0,
						borderRadius: '10px',
					}}
					allowFullScreen
					loading="lazy"
					referrerPolicy="no-referrer-when-downgrade"
					title="Namo Cars – Self Drive Car Rental in Udaipur on Google Map"
				></iframe>

				<div className="text-center mt-3">
					<a
						href="https://maps.app.goo.gl/WKDqqdDtCH1xUUyN7"
						target="_blank"
						rel="noreferrer" 
						className="btn btn-success">
						📍 Open Namo Cars on Google Map
					</a>
				</div>
			</section>
			{/* ✅ Google Map Embed Section */}
			<Footer />
		</div>
	);
};

export default Contact;
